<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1901buddhismisnotscary">CHAPTER 1901 - BUDDHISM IS NOT SCARY</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter1902buddhanations">CHAPTER 1902 - BUDDHA NATIONS</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter1903quotientcountermeasure">CHAPTER 1903 - QUOTIENT COUNTERMEASURE</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter1904boldideas">CHAPTER 1904 - BOLD IDEAS</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter1905buddhistsutra">CHAPTER 1905 - BUDDHIST SUTRA</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter1906cardiacbreakthrough">CHAPTER 1906 - CARDIAC BREAKTHROUGH</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter1907buddhistbeings">CHAPTER 1907 - BUDDHIST BEINGS</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter1908everythingisanillusion">CHAPTER 1908 - EVERYTHING IS AN ILLUSION</a>
</li>
<li class="table-of-content">
<a href="#/8_chapter1909itisnottruethatwhatyouseewithyoureyesisnottrue">CHAPTER 1909 - IT IS NOT TRUE THAT WHAT YOU SEE WITH YOUR EYES IS NOT TRUE</a>
</li>
<li class="table-of-content">
<span href="#/9_chapter1910buddhistobjects" title="Link target outside of Sample">CHAPTER 1910 - BUDDHIST OBJECTS</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter1911octahedralbuddhistmirror" title="Link target outside of Sample">CHAPTER 1911 - OCTAHEDRAL BUDDHIST MIRROR</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter1912chulingduo" title="Link target outside of Sample">CHAPTER 1912 - CHULING DUO</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter1913agoodsenseofdominance" title="Link target outside of Sample">CHAPTER 1913 - A GOOD SENSE OF DOMINANCE</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter1914buddhistitemsarenotsomethingyoucantracewithyourfinger" title="Link target outside of Sample">CHAPTER 1914 - BUDDHIST ITEMS ARE NOT SOMETHING YOU CAN TRACE WITH YOUR FINGER</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter1915dharmaappearance" title="Link target outside of Sample">CHAPTER 1915 - DHARMA APPEARANCE</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter1916allofyouarenothingmorethanthis" title="Link target outside of Sample">CHAPTER 1916 - ALL OF YOU ARE NOTHING MORE THAN THIS …</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter1917goldenfog" title="Link target outside of Sample">CHAPTER 1917 - GOLDEN FOG</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter1918shatteredimmortalpalace" title="Link target outside of Sample">CHAPTER 1918 - SHATTERED IMMORTAL PALACE</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter1919lisheng" title="Link target outside of Sample">CHAPTER 1919 - LI SHENG?</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter1920flyingknifepath" title="Link target outside of Sample">CHAPTER 1920 - FLYING KNIFE PATH</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter1921knifequestion" title="Link target outside of Sample">CHAPTER 1921 - KNIFE QUESTION</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter1922entertheworldbyfeeling" title="Link target outside of Sample">CHAPTER 1922 - ENTER THE WORLD BY FEELING</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter1923thedreamofthejiuzhou" title="Link target outside of Sample">CHAPTER 1923 - THE DREAM OF THE JIUZHOU</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter1924heavenlylawpalace" title="Link target outside of Sample">CHAPTER 1924 - HEAVENLY LAW PALACE</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter1925qinxiaosheart" title="Link target outside of Sample">CHAPTER 1925 - QIN XIAO'S HEART</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter1926xinxinmoresecure" title="Link target outside of Sample">CHAPTER 1926 - XINXIN MORE SECURE</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter1927keysandlocks" title="Link target outside of Sample">CHAPTER 1927 - KEYS AND LOCKS</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter1928loveknife" title="Link target outside of Sample">CHAPTER 1928 - LOVE KNIFE</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter1929brokenknifeformation" title="Link target outside of Sample">CHAPTER 1929 - BROKEN KNIFE FORMATION</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter1930treasureallocation" title="Link target outside of Sample">CHAPTER 1930 - TREASURE ALLOCATION</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter1931sabreking" title="Link target outside of Sample">CHAPTER 1931 - SABRE KING</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter1932comprehensionsociety" title="Link target outside of Sample">CHAPTER 1932 - COMPREHENSION SOCIETY</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter1933snatchtoken" title="Link target outside of Sample">CHAPTER 1933 - SNATCH TOKEN</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter1934brotherlyaffection" title="Link target outside of Sample">CHAPTER 1934 - BROTHERLY AFFECTION</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter1935guestathome" title="Link target outside of Sample">CHAPTER 1935 - GUEST AT HOME</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter1936huakuicompetitionconference" title="Link target outside of Sample">CHAPTER 1936 - HUA KUI COMPETITION CONFERENCE</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter1937thecourtesanbelleofthethreestepascendant" title="Link target outside of Sample">CHAPTER 1937 - THE COURTESAN BELLE OF THE THREE-STEP ASCENDANT</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter1938ninetrials" title="Link target outside of Sample">CHAPTER 1938 - NINE TRIALS</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter1939youdaretofight" title="Link target outside of Sample">CHAPTER 1939 - YOU DARE TO FIGHT?</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter1940thefiascoended" title="Link target outside of Sample">CHAPTER 1940 - THE FIASCO ENDED</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter1941xirenlongscondition" title="Link target outside of Sample">CHAPTER 1941 - XI RENLONG'S CONDITION</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter1942secondstage" title="Link target outside of Sample">CHAPTER 1942 - SECOND STAGE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter1943howcouldyou" title="Link target outside of Sample">CHAPTER 1943 - HOW COULD YOU?</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter1944newvictory" title="Link target outside of Sample">CHAPTER 1944 - NEW VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter1945washeevenhuman" title="Link target outside of Sample">CHAPTER 1945 - WAS HE EVEN HUMAN?</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter1946yuwenqiong" title="Link target outside of Sample">CHAPTER 1946 - YUWEN QIONG</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter1947xirenlongsoppression" title="Link target outside of Sample">CHAPTER 1947 - XI RENLONG'S OPPRESSION</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter1948youarecourtingdeath" title="Link target outside of Sample">CHAPTER 1948 - YOU ARE COURTING DEATH!]</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter1949yuqingavengedhimself" title="Link target outside of Sample">CHAPTER 1949 - YU QING AVENGED HIMSELF</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter1950qinxiaosdetermination" title="Link target outside of Sample">CHAPTER 1950 - QIN XIAO'S DETERMINATION</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter1951zygocentric" title="Link target outside of Sample">CHAPTER 1951 - ZYGOCENTRIC</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter1952torespecttheheartandactasonesownmind" title="Link target outside of Sample">CHAPTER 1952 - TO RESPECT THE HEART AND ACT AS ONE'S OWN MIND</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter1953medallion" title="Link target outside of Sample">CHAPTER 1953 - MEDALLION</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter1954verbatim" title="Link target outside of Sample">CHAPTER 1954 - VERBATIM</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter1955innocent" title="Link target outside of Sample">CHAPTER 1955 - INNOCENT</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter1956fightqiuwu" title="Link target outside of Sample">CHAPTER 1956 - FIGHT QIU WU</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter1957begformercy" title="Link target outside of Sample">CHAPTER 1957 - BEG FOR MERCY</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter1958downthesteps" title="Link target outside of Sample">CHAPTER 1958 - DOWN THE STEPS</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter1959ahintofprofoundmeaning" title="Link target outside of Sample">CHAPTER 1959 - A HINT OF PROFOUND MEANING</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter1960descentofthetinimmortals" title="Link target outside of Sample">CHAPTER 1960 - DESCENT OF THE TIN IMMORTALS</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter1961beyoungandshouldbefrivolous" title="Link target outside of Sample">CHAPTER 1961 - BE YOUNG AND SHOULD BE FRIVOLOUS</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter1962activatedhongming" title="Link target outside of Sample">CHAPTER 1962 - ACTIVATED HONGMING</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter1963theheavenlymountaincitylorddescended" title="Link target outside of Sample">CHAPTER 1963 - THE HEAVENLY MOUNTAIN CITY LORD DESCENDED.</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter1964comprehensionhasamantra" title="Link target outside of Sample">CHAPTER 1964 - COMPREHENSION HAS A MANTRA</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter1965seeheavenlymountaincitylord" title="Link target outside of Sample">CHAPTER 1965 - SEE HEAVENLY MOUNTAIN CITY LORD</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter1966lookatyourgoodfortune" title="Link target outside of Sample">CHAPTER 1966 - LOOK AT YOUR GOOD FORTUNE</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter1967twostepstoheavenqinxiao" title="Link target outside of Sample">CHAPTER 1967 - TWO STEPS TO HEAVEN QIN XIAO</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter1968walkyourway" title="Link target outside of Sample">CHAPTER 1968 - WALK YOUR WAY</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter1969robbery" title="Link target outside of Sample">CHAPTER 1969 - ROBBERY</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter1970illjustgiveittoyouguys" title="Link target outside of Sample">CHAPTER 1970 - I'LL JUST GIVE IT TO YOU GUYS</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter1971thedarkishqinxiao" title="Link target outside of Sample">CHAPTER 1971 - THE DARKISH QIN XIAO</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter1972begformercy" title="Link target outside of Sample">CHAPTER 1972 - BEG FOR MERCY</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter1973showofgoodfaith" title="Link target outside of Sample">CHAPTER 1973 - SHOW OF GOOD FAITH</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter1974exchangesecrettechniques" title="Link target outside of Sample">CHAPTER 1974 - EXCHANGE SECRET TECHNIQUES</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter1975qinxiaosconsideration" title="Link target outside of Sample">CHAPTER 1975 - QIN XIAO'S CONSIDERATION</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter1976theenergyoftheimmortalunionchamberofcommerce" title="Link target outside of Sample">CHAPTER 1976 - THE ENERGY OF THE IMMORTAL UNION CHAMBER OF COMMERCE</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter1977disciplelargecompetition" title="Link target outside of Sample">CHAPTER 1977 - DISCIPLE LARGE COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter1978righteousindignation" title="Link target outside of Sample">CHAPTER 1978 - RIGHTEOUS INDIGNATION</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter1979thereshouldberighteousnessinhisheart" title="Link target outside of Sample">CHAPTER 1979 - THERE SHOULD BE RIGHTEOUSNESS IN HIS HEART</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter1980knifedecision" title="Link target outside of Sample">CHAPTER 1980 - KNIFE DECISION</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter1981thelordoffuyanimmortalpalacedescended" title="Link target outside of Sample">CHAPTER 1981 - THE LORD OF FUYAN IMMORTAL PALACE DESCENDED.</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter1982heavenspride" title="Link target outside of Sample">CHAPTER 1982 - HEAVEN'S PRIDE</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter1983promotethesonofpride" title="Link target outside of Sample">CHAPTER 1983 - PROMOTE THE SON OF PRIDE</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter1984thebenefitsofproudchildren" title="Link target outside of Sample">CHAPTER 1984 - THE BENEFITS OF PROUD CHILDREN</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter1985brokensword" title="Link target outside of Sample">CHAPTER 1985 - BROKEN SWORD</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter1986asliverofholypower" title="Link target outside of Sample">CHAPTER 1986 - A SLIVER OF HOLY POWER</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter1987inviolablewill" title="Link target outside of Sample">CHAPTER 1987 - INVIOLABLE WILL</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter1988youdontneedareasontohatesomeone" title="Link target outside of Sample">CHAPTER 1988 - YOU DON'T NEED A REASON TO HATE SOMEONE</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter1989zizyphushirsutum" title="Link target outside of Sample">CHAPTER 1989 - ZIZYPHUS HIRSUTUM</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter1990hehadtoagreeevenifhedidntwantto" title="Link target outside of Sample">CHAPTER 1990 - HE HAD TO AGREE EVEN IF HE DIDN'T WANT TO</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter1991compromise" title="Link target outside of Sample">CHAPTER 1991 - COMPROMISE</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter1992immortalwitheredcloudsdeduction" title="Link target outside of Sample">CHAPTER 1992 - IMMORTAL WITHERED CLOUD'S DEDUCTION</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter1993unbelievable" title="Link target outside of Sample">CHAPTER 1993 - UNBELIEVABLE</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter1994dragonslayingsword" title="Link target outside of Sample">CHAPTER 1994 - DRAGON-SLAYING SWORD</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter1995allthetimewaitingforyou" title="Link target outside of Sample">CHAPTER 1995 - ALL THE TIME WAITING FOR YOU</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter1996limitlessdeparturefield" title="Link target outside of Sample">CHAPTER 1996 - LIMITLESS DEPARTURE FIELD</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter1997selectionoftheholyconsort" title="Link target outside of Sample">CHAPTER 1997 - SELECTION OF THE HOLY CONSORT</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter1998atransaction" title="Link target outside of Sample">CHAPTER 1998 - A TRANSACTION</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter1999enemieshaveanarrowroad" title="Link target outside of Sample">CHAPTER 1999 - ENEMIES HAVE A NARROW ROAD</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter2000barbarianlife" title="Link target outside of Sample">CHAPTER 2000 - BARBARIAN LIFE</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?350a2dd8